module.exports = __webpack_public_path__ + "static/media/inventory-slot.907af835.png";